import React from 'react';
import { useSelector } from 'react-redux';
import { ACCREDITATIONS } from 'mock';
import TickCircle from 'assets/svgs/TickCircle.svg';

function AccreditationsList({ accreditations: accreditationsProp }) {
  const { installers: installer } = useSelector((state) => state.installer);

  const source = accreditationsProp ?? installer?.accreditations ?? [];
  const filtered = Array.isArray(source) ? source.filter(Boolean) : [];

  return (
    <div className='flex flex-col gap-[17px]'>
      <div className='flex flex-column'>
        <p className='text-gray3 font-bold text-[15px]'>Accreditations</p>
        <p className='text-gray3 font-[400] text-[15px]'>
          Industry accreditations held by this installer
        </p>
      </div>
      {filtered.length === 0 ? (
        <p className='text-sm text-gray3 italic'>
          No accreditations added yet
        </p>
      ) : (
        <div className='flex flex-wrap gap-3'>
          {filtered.map((name, index) => {
            const match = ACCREDITATIONS?.find(
              (a) => a.name.toLowerCase() === name.toLowerCase()
            );
            const label = match ? match.title : name;
            return (
              <div
                key={index}
                className='inline-flex items-center gap-2 bg-secondary rounded-full pl-2 pr-4 py-1.5 shadow-light'
              >
                <img src={TickCircle} alt='' className='h-[18px] w-[18px]' />
                <p className='text-sm text-primaryDark font-[600] tracking-wide'>
                  {label}
                </p>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

export { AccreditationsList };
